import Api from "@/utils/axios";

export default {
  namespaced: true,
  state: {
    about: [],
    sliders: [],
    categories: [],
    terms: null,
    privacy: null,
    contacts:{},
    isLoading: false,
    termsAndConditions:null,
    noProductsDataForSearch: null,
    noCompaniesDataForSearch: null,
  },

  getters: {
    getAbout(state) {
      return state.about;
    },
    getSliders(state) {
      return state.sliders;
    },
    getCategories(state) {
      return state.categories;
    },
    getTerms(state) {
      return state.terms;
    },
    getPrivacy(state) {
      return state.privacy;
    },
    getContacts(state) {
      return state.contacts;
    },
    getLoading(state) {
      return state.isLoading;
    },
    getTermsAndConditions(state) {
      return state.termsAndConditions;
    },
    getNoProductsDataForSearch(state){
      return state.noProductsDataForSearch
    },
    getNoCompaniesDataForSearch(state){
      return state.noCompaniesDataForSearch
    },
  },
  mutations: {
    SET_ABOUT(state, info) {
      state.about = info;
    },
    SET_SLIDERS(state, slider) {
      state.sliders = slider;
    },
    SET_CATEGORIES(state, category) {
      state.categories = category;
    },
    SET_TERMS(state, term) {
      state.terms = term;
    },
    SET_PRIVACY(state, priv) {
      state.privacy = priv;
    },
    SET_CONTACTS(state, contact) {
      state.contacts = contact;
    },
    SET_LOADING(state, isLoading ) {
      state.isLoading  = isLoading ;
    },
    SET_TERMS_AND_CONDITIONS(state, text ) {
      state.termsAndConditions  = text ;
    },
  },
  actions: {
    // Get Home Sliders && Categories
    async handlerHomeData({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("home").then((response)=>{
          commit("SET_SLIDERS", response.data.sliders)
          commit("SET_CATEGORIES", response.data.categories)
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Get About Us Data
    async handlerAboutUsData({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("about").then((response)=>{
          commit("SET_ABOUT", response.data)
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Get Terms
    async handlerTermsData({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("terms").then((response)=>{
          let termsValue = response.data
          console.log(response.data);
          commit("SET_TERMS",termsValue)
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Get Privacy
    async handlerPrivacyData({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("privacy").then((response)=>{
          commit("SET_PRIVACY", response.data)
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Get Contact
    async handlerContactData({commit}) {
      return await new Promise((resolve, reject) => {
        Api.get("contact").then((response)=>{
          commit("SET_CONTACTS", response.data)
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    
    // Handler Contact Us
    async handlerContactUs({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("contact-us", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Rate Product 
    async handlerRateProduct({commit}, payload) {
      return await new Promise((resolve, reject) => {
        Api.post("rate", payload).then((response)=>{
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },

    async handlerTermsConditionsData({commit}, id) {
      return await new Promise((resolve, reject) => {
        Api.get(`terms/${id}`).then((response)=>{
          commit("SET_TERMS_AND_CONDITIONS", response.data);
         
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
    // Handler Search
    async handlerSearch({commit, state}, name) {
      return await new Promise((resolve, reject) => {
        Api.get(`search?name=${name}`).then((response)=>{
          commit("sales/SET_Sales", response.data.companies, { root: true });
          state.noProductsDataForSearch = response.data.products.length
          state.noCompaniesDataForSearch = response.data.companies.length
        
          resolve(response)
        }).catch((error)=>{
          reject(error)
        })
      })
    },
  },
};
